"use client"

import { Apple } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `AppleIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const AppleIcon = component(Icon)({ as: Apple })
